import { useEffect, useState } from "react";

const ANAHTAR = "erp-mod";

export const modUygula = (m) => {
  if (m === "gunduz") document.documentElement.setAttribute("data-mode", "gunduz");
  else document.documentElement.removeAttribute("data-mode");
};
export const modOku = () => localStorage.getItem(ANAHTAR) || "gece";
export const modKaydet = (m) => { localStorage.setItem(ANAHTAR, m); modUygula(m); window.dispatchEvent(new Event(ANAHTAR)); };
export const siteYolu = (p) => p === "/site" || p.startsWith("/site/");

export const useMod = () => {
  const [mod, setMod] = useState(modOku);
  useEffect(() => {
    const f = () => setMod(modOku());
    window.addEventListener(ANAHTAR, f);
    return () => window.removeEventListener(ANAHTAR, f);
  }, []);
  return mod;
};
